import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const financeApi = createApi({
  reducerPath: 'finance',


  baseQuery: createBaseQueryWithReauth(''),

  tagTypes: ['Accruals'],

  endpoints: builder => ({
    getAccruals: builder.query({
      query: ({ page = 1, from, to } = {}) => {
        // Створюємо об'єкт параметрів запиту
        const params = {
          page, // додаємо параметр page до запиту
        };

        // Додаємо параметри 'from' та 'to', якщо вони задані
        if (from && to) {
          params.from = from;
          params.to = to;
        }


        return {
          url: `/accruals/`,
          method: 'GET',
          params, // передаємо параметри запиту
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Accruals'],
    }),
  }),
});

export const {
  useGetAccrualsQuery,
} = financeApi;